/**
 * Contact Form 7 Loading State Handler
 */
class ContactFormLoader {
	constructor() {
		this.init();
	}

	init() {
		// Wait for DOM to be ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () =>
				this.bindEvents()
			);
		} else {
			this.bindEvents();
		}
	}

	bindEvents() {
		document
			.querySelectorAll('.wpcf7 input[type="checkbox"]')
			.forEach(function (checkbox) {
				checkbox.addEventListener('change', function (e) {
					e.stopPropagation(); // helps!
				});
			});
		// Listen for CF7 events
		document.addEventListener('wpcf7mailsent', (event) =>
			this.handleSuccess(event)
		);
		document.addEventListener('wpcf7mailfailed', (event) =>
			this.handleError(event)
		);
		document.addEventListener('wpcf7invalid', (event) =>
			this.handleValidationError(event)
		);
		document.addEventListener('wpcf7spam', (event) =>
			this.handleSpam(event)
		);
		document.addEventListener('wpcf7submit', (event) =>
			this.handleSubmit(event)
		);

		// Also handle form submission via submit event as fallback
		this.attachSubmitHandlers();

		// Initialize loaders for existing forms
		this.initializeLoaders();
	}

	attachSubmitHandlers() {
		const forms = document.querySelectorAll('.wpcf7-form');

		forms.forEach((form) => {
			const submitButton = form.querySelector('button[type="submit"]');

			if (submitButton) {
				form.addEventListener('submit', () => {
					this.setLoadingState(form, true);
				});
			}
		});
	}

	initializeLoaders() {
		const forms = document.querySelectorAll('.wpcf7-form');

		forms.forEach((form) => {
			const submitButton = form.querySelector('button[type="submit"]');

			if (submitButton && !submitButton.querySelector('.loader')) {
				this.createLoader(submitButton);
			}
		});
	}

	createLoader(submitButton) {
		if (!submitButton) return;

		// Create loader div
		const loader = document.createElement('div');
		loader.className = 'loader';
		loader.style.display = 'none';

		// Insert loader inside the button
		submitButton.appendChild(loader);
	}

	handleSubmit(event) {
		// Log the submit event
		const form = event.target.closest('.wpcf7-form');
		const isInvalid = form.classList.contains('invalid');

		if (form) {
			this.setLoadingState(form, !isInvalid);
		}
	}

	handleSuccess(event) {
		const form = event.target.closest('.wpcf7-form');
		if (form) {
			this.setLoadingState(form, false);
		}
	}

	handleError(event) {
		const form = event.target.closest('.wpcf7-form');
		if (form) {
			this.setLoadingState(form, false);
		}
	}

	handleValidationError(event) {
		// Log validation error details
		const form = event.target.closest('.wpcf7-form');
		if (form) {
			this.setLoadingState(form, false);
		}
	}

	handleSpam(event) {
		const form = event.target.closest('.wpcf7-form');
		if (form) {
			this.setLoadingState(form, false);
		}
	}

	setLoadingState(form, isLoading) {
		if (!form) return;

		const submitButton = form.querySelector('button[type="submit"]');
		const loader = this.getLoader(submitButton);
		const buttonText = submitButton ? submitButton.childNodes[0] : null;

		if (isLoading) {
			// Hide button text and show loader
			if (submitButton) {
				// Store original text content
				if (buttonText && buttonText.nodeType === Node.TEXT_NODE) {
					submitButton.dataset.originalText = buttonText.textContent;
					buttonText.textContent = '';
				}
				submitButton.disabled = true;
				submitButton.classList.add('cf7-loading');
			}

			if (loader) {
				loader.style.display = 'flex';
			}
		} else {
			// Restore button text and hide loader
			if (submitButton) {
				// Restore original text
				if (buttonText && buttonText.nodeType === Node.TEXT_NODE) {
					buttonText.textContent =
						submitButton.dataset.originalText || 'Submit';
				}
				submitButton.disabled = false;
				submitButton.classList.remove('cf7-loading');
			}

			if (loader) {
				loader.style.display = 'none';
			}
		}
	}

	getLoader(submitButton) {
		if (!submitButton) return null;

		// Look for loader inside the button
		return submitButton.querySelector('.loader');
	}

	handleChange() {
		// Log the change event
	}

	removeOnChangeListeners() {
		const forms = document.querySelectorAll('.wpcf7-form');

		forms.forEach((form) => {
			form.removeEventListener('change', this.handleChange);
		});
	}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
	new ContactFormLoader();
});

// Also initialize immediately if DOM is already loaded
if (document.readyState !== 'loading') {
	new ContactFormLoader();
}
